import { TAnalyticsNotesCommonState } from './types';

export function getCountryDeclensions(state: TAnalyticsNotesCommonState) {
  return state.countryDeclensions;
}
